import { IOptions } from './../../../../models/optionsets.interface';
import { Component, OnInit, Output, EventEmitter, Input, NgZone, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl, AbstractControl } from '@angular/forms';

import { Subscription, Subject } from 'rxjs';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import * as _moment from 'moment';
import { IProgramCycle } from './../../../../models/programcycle.interface';
import { IDwellingInput } from '../../../../models/dwellingInput.interface';
import { IDwellingReturned } from './../../../../models/dwellingInput.interface';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { AppLoadService, HelpApiService, IHelp } from '@ebb-v2/ebb-integration';
import { set } from 'lodash';

declare const google: any;

const moment = _moment;
export const MY_FORMATS = {
  parse: {
    dateInput: 'YYYY'
  },
  display: {
    dateInput: 'YYYY',
    yearLabel: 'YYYY'
  }
};

@Component({
  selector: 'ebb-start',
  templateUrl: './start.component.html',
  styleUrls: ['./start.component.scss'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [ MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS ]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})
export class StartComponent implements OnInit {
  public dwellingInput: FormGroup;
  @Input() programName: string;
  @Input() program: IProgramCycle;
  @Input() dwelling$: Subject<IDwellingReturned>;
  @Output() nextSection: EventEmitter<number> = new EventEmitter<number>();
  @Output() isFormInvalid: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() emitDwelling: EventEmitter<IDwellingInput | IDwellingReturned> = new EventEmitter<IDwellingInput | IDwellingReturned>();
 
  public acceptedZipCodes: string[];
  public displayDate: FormControl = new FormControl(moment());
  public address$: Subscription;
  public placesService = null;
  public listResults: any[] = [];
  public yearBuiltArray: string[] = [];
  public listHelp: IHelp[] = [];
  public _policies: IOptions[];
  public _beforestreetnumber:number;
  public _afterstreetnumber:number;
  public programTypeCodeOptionSet: string;
  drawerOpen = false;
  drawerContent: SafeHtml = '';

  @Input() set policies(value: IOptions[]) {
    this._policies = value;
    this.enablePiEntry(true);
  }

  public _dwellingNextInProcess = false;
  @Input() set dwellingNextInProcessComplete(value: boolean) {
    this._dwellingNextInProcess = !value;
  }

  @ViewChild('address_Street') address_Street: ElementRef;
  @ViewChild('address_Street_Line2') address_Street_Line2: ElementRef;
  @ViewChild('address_City') address_City: ElementRef;
  @ViewChild('address_State') address_State: ElementRef;
  @ViewChild('address_Zip') address_Zip: ElementRef;

  constructor(
    private _fb: FormBuilder,
    public zone: NgZone,
    private readonly apiHelp: HelpApiService,
    public sanitizer: DomSanitizer,
    private appLoadService: AppLoadService
  ) { }

  public ngOnInit(): void {

    this.loadHelpText();
    this.placesService = new google.maps.places.PlacesService(window.document.createElement('div'));
    this.acceptedZipCodes = this.program.zipCodesAccepted.split(',').map(zip => zip.trim());
    this.constructYearBuiltArray(this.program);

    this.dwellingInput = this._fb.group({
      address_Street: ['', [Validators.required, Validators.maxLength(100), this.validateAddress]],
      address_Street_Line2: ['', [Validators.maxLength(100), Validators.pattern(/^((?!\@).)*$/)]],
      address_City: ['', [Validators.required, Validators.maxLength(100), Validators.pattern(/^((?!\@).)*$/)]],
      address_State: ['CA', [Validators.required, Validators.pattern(/^((?!\@).)*$/)]],
      address_Zip: ['', [Validators.required, Validators.maxLength(10), Validators.pattern(/^((?!\@).)*$/), ((c: AbstractControl) => {
        //open to all zip codes
        if (!this.acceptedZipCodes || this.acceptedZipCodes.length === 0 || 
          (this.acceptedZipCodes.length === 1 && this.acceptedZipCodes[0] === '')) {
          return null;
        }
        //check zip code
        if (this.acceptedZipCodes.length && this.acceptedZipCodes.includes(c.value)) {
          return null;
        }
        return { zipNotIncluded: true }
      })]],
      yearBuilt: ['', [
        Validators.required,
        Validators.min(parseInt(this.program.yearBuiltBeginDate, 10)),
        Validators.max(parseInt(this.program.yearBuiltEndDate, 10))
      ]],
      homeownerOccupied: [null, Validators.required],
      _Ebb_ProgramCycleId: [null, Validators.required]
    });
    if (this.program && this.program.homeownerOccupied) {
      this.dwellingInput.get('homeownerOccupied').setValidators([Validators.requiredTrue]);
    }
    this.enablePiEntry(true);

    this.dwelling$.subscribe((storedDwelling) => {
      this.dwellingInput.patchValue({ _Ebb_ProgramCycleId: storedDwelling._Ebb_ProgramCycleId});
      if(storedDwelling.address_Street){
        this.dwellingInput.get('address_Street').setValue(storedDwelling.address_Street);
        this._beforestreetnumber = this.startnumber(storedDwelling.address_Street)
        console.log("_beforestreetnumber"+this._beforestreetnumber.toString());
        this.dwellingInput.get('address_Street').markAsTouched();
        this.dwellingInput.get('address_Street_Line2').setValue(storedDwelling.address_Street_Line2);
        this.dwellingInput.get('address_Street_Line2').markAsTouched();
        this.dwellingInput.get('address_City').setValue(storedDwelling.address_City);
        this.dwellingInput.get('address_City').markAsTouched();
        this.dwellingInput.get('address_Zip').setValue(storedDwelling.address_Zip);
        this.dwellingInput.get('address_Zip').markAsTouched();
        this.dwellingInput.get('yearBuilt').setValue(storedDwelling.yearBuilt);
        this.dwellingInput.get('yearBuilt').markAsTouched();
        this.dwellingInput.get('address_State').setValue('CA');
        this.dwellingInput.get('address_State').markAsTouched();
        if(storedDwelling.homeownerOccupied == true){
          this.dwellingInput.get('homeownerOccupied').setValue(true);
          this.dwellingInput.get('homeownerOccupied').markAsTouched();
        }else if(storedDwelling.homeownerOccupied == false){
          this.dwellingInput.get('homeownerOccupied').setValue(false);
          this.dwellingInput.get('homeownerOccupied').markAsTouched();
        }
        
      }
    });

    this.dwellingInput.valueChanges.subscribe(x => {
      this.isFormInvalid.emit(this.dwellingInput.invalid);
    });
  }
  private loadHelpText(): void {
    const programLocalStore = localStorage.getItem('ebbprogram');
      if (window['program']) {
        this.programTypeCodeOptionSet = window['program'];
      } else if (programLocalStore) {
        this.programTypeCodeOptionSet = programLocalStore;
      } else {
        this.programTypeCodeOptionSet = 'FEMA|EBB'; //default to EBB programs
      }
      const settings = this.appLoadService.readEnvironSettings();
    this.apiHelp
      .getList()
      .subscribe(
        data => {
          this.listHelp = JSON.parse(JSON.stringify(data));
          let indexHelpContractor = this.listHelp.findIndex(i => i.name.toLowerCase() === 'ebbyearbuilt');
          if(settings.ProgramIsCeaBb){
            indexHelpContractor = this.listHelp.findIndex(i => i.name.toLowerCase() === 'ceabbyearbuilt');
          }
          if(settings.ProgramIsEss){
            indexHelpContractor = this.listHelp.findIndex(i => i.name.toLowerCase() === 'essyearbuilt');
          }
          if(settings.ProgramIsEmr){
            indexHelpContractor = this.listHelp.findIndex(i => i.name.toLowerCase() === 'emryearbuilt');
          }
          this.drawerContent = this.formatHelptext(this.listHelp[indexHelpContractor].answer);
          
        },
        error => console.log(error)
      );
  }
public validateAddress(c: FormControl) {
  
    let AddressRegex = /^(\d{1,}[a-zA-Z0-9-/.#]?) [a-zA-Z0-9-/.\s#]+$/; 
    let PoRegex = /\b(p|P)(ost|ostal)?([ \.]*(O|o|0)(ffice)?)?([ \.]*(b|B)(o|O|0)(x|X))\b/;  
  
    return (AddressRegex.test(c.value) && !PoRegex.test(c.value)) ? null : {
      validateAddress: {
        valid: false
      }
    };
  }

public startnumber(streetaddress:string){

  var startingNumber = ( streetaddress
  .match(/\d+\.\d+|\d+\b|\d+(?=\w)/g) || [] )
  .map(function (v) {return +v;}).shift();

  return startingNumber;
}
  public constructYearBuiltArray(program: IProgramCycle): void {
    if (program.yearBuiltBeginDate && program.yearBuiltEndDate) {
      for (let i = parseInt(program.yearBuiltEndDate, 10); i >= parseInt(program.yearBuiltBeginDate, 10); i--) {
        this.yearBuiltArray.push(i.toString());
      }
    } else {
      for (let i = 1980; i >= 1800; i--) {
        this.yearBuiltArray.push(i.toString());
      }
    }
  }

  public onFocus(event: Event): void {
    window['angularGooglePlaceDetailRef'] = { component: this, zone: this.zone };
  }

  public openDropdown(predictions: any[]): void {
    this.listResults = predictions;
  }

  public getPlaceDetails(result: any): void {
    this.placesService.getDetails({ placeId: result.place_id }, this.fillInAddress);
  }

  public fillInAddress(place: any, status: any): void {
    let address = '';
    let address2 = '';
    let zip = '';
    let city = '';

    place.address_components.forEach((comp: any) => {
      const addressType = comp.types[0];

      switch (addressType) {
        case 'street_number':
        case 'route':
          address += ' ' + comp['short_name'];
          break;
          case 'subpremise':
          address2 += ' ' + comp['short_name'];
          break;
          case 'locality':
                 
          city = comp['long_name'];
          break;
          case 'postal_code':
          zip = comp['short_name'];
          break;
      }
    });

    window['angularGooglePlaceDetailRef'].zone.run(() => {
      const comp = window['angularGooglePlaceDetailRef'].component;
      comp.dwellingInput.patchValue({
        address_Street: address.trim(),
        address_Street_Line2 :address2.trim(),
        address_City: city.trim(),
        address_Zip: zip.trim()
      }, { emitEvent: false });
      comp.dwellingInput.get('address_Street').markAsTouched();
      comp.dwellingInput.get('address_Street_Line2').markAsTouched();
      comp.dwellingInput.get('address_City').markAsTouched();
      comp.dwellingInput.get('address_Zip').markAsTouched();
      comp.dwellingInput.get('address_Street').markAsDirty();
      comp.dwellingInput.get('address_City').markAsDirty();
      comp.dwellingInput.get('address_Zip').markAsDirty();
    });
  }
  public enablePiEntry(enable: boolean): void {
    if (enable && this._policies && this.dwellingInput) {
      this.dwellingInput.addControl('pi', new FormControl('', Validators.required));
    } else if(this.dwellingInput) {
      this.dwellingInput.removeControl('pi');
    }
  }

  public onKey(e: any): void {
    const key = e.keyCode;
    let $selected = this.listResults.findIndex(element => element.selected === true);

    if (key === 40) {
      if (!this.listResults.length || this.listResults.length <= $selected + 1) {
        $selected = 0;
      } else {
        $selected += 1;
      }
      for (let i = 0; i <this.listResults.length; i++) {
        if (i === $selected) {
          this.listResults[i].selected = true;
          continue;
        }
        this.listResults[i].selected = false;
      }
    } else if (key === 38) {
      if (!this.listResults.length || $selected <= 0) {
        $selected = this.listResults.length + 1;
      } else {
        $selected -= 1;
      }

      for (let i = 0; i < this.listResults.length; i++) {
        if (i === $selected) {
          this.listResults[i].selected = true;
          continue;
        }
        this.listResults[i].selected = false;
      }
    } else if (key === 13) {
      if (this.listResults.length > 0) {
        console.log(this.listResults[$selected]);
        this.getPlaceDetails(this.listResults[$selected]);
        this.listResults = [];
      }
       e.preventDefault();
    }
  }

  public toNextSection(): void {
    const dwelling: IDwellingReturned = this.dwellingInput.getRawValue();
   this._afterstreetnumber = this.startnumber(dwelling.address_Street);
   console.log("_afterstreetnumber"+this._afterstreetnumber.toString());
   let addresschange = false;
   if(this._beforestreetnumber !=0 && this._beforestreetnumber != this._afterstreetnumber){
    addresschange = true;
 
    

    console.log("clear");
   }
    this.isFormInvalid.emit(false);
    this._dwellingNextInProcess = true;
    if (this.dwelling$) {
      this.dwelling$.subscribe((storedDwelling) => {
        dwelling.id = storedDwelling.id;
        
          var name = "addresschange" + storedDwelling.id;
          this.setCookie(name, addresschange==true?"true":"false", 1);
        
       
        this.emitDwelling.emit(dwelling);
      }).unsubscribe();
    } else {
      this.emitDwelling.emit(dwelling);
    }
    this.dwellingInput.markAsPristine();
  }

  public continueEnabled(): boolean {
    if (this.dwellingInput.valid && !this._dwellingNextInProcess) {
      return true;
    }
    return false;
  }

  private setCookie(name, value, days) {
    var expires = '';
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + (value || '') + expires + '; path=/';
  }
  showMoreYearBuild(): void {
   // this.drawerContent ="Single-family Wood-frame Retrofit (CEA HRD)  https://www.youtube.com/watch?v=gQAa0u7e20Q";
    this.drawerOpen = true; // Optional: open the drawer when content is set
  }
  toggleDrawer(): void {
    this.drawerOpen = !this.drawerOpen;
  }
  public formatHelptext(content: string): SafeHtml {
    let resultHtml = content;
    if (!resultHtml) return resultHtml;

    resultHtml = this.youTubeLinks(resultHtml);
    resultHtml = this.vemioLinks(resultHtml);
    resultHtml = resultHtml.replace(/(\r\n|\n|\r)/gm, '<br/>');
    return this.sanitizer.bypassSecurityTrustHtml(resultHtml);
  }

  public youTubeLinks(content: string): string {
    let resultHtml = content;
    if (!resultHtml) return resultHtml;

    const fullreg = /(https?:\/\/)?(www\.)?(youtube\.com\/watch\?v=|youtu\.be\/)([^& \n<]+)(?:[^ \n<]+)?(\r\n|\n|\r|$)/g;
    const regex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/watch\?v=|youtu\.be\/)([^& \n<]+)(?:[^ \n<]+)?(\r\n|\n|\r|$)/g;
    const match = resultHtml.match(fullreg);
    if (match && match.length > 0) {
      for (let i = 0; i < match.length; i++) {
        const matchParts = match[i].split(regex);
        resultHtml = resultHtml.replace(
          match[i],
          this.createYoutubeEmbed(matchParts[1])
        );
      }
    }
    return resultHtml;
  }

  public vemioLinks(content: string): string {
    let resultHtml = content;
    if (!resultHtml) return resultHtml;

    const fullreg = /(https?:\/\/)?(www\.)?(vimeo.com\/)([^& \n<]+)(?:[^ \n<]+)?(\r\n|\n|\r|$)/g;
    const regex = /(?:https?:\/\/)?(?:www\.)?(?:vimeo.com\/)([^& \n<]+)(?:[^ \n<]+)?(\r\n|\n|\r|$)/g;
    const match = resultHtml.match(fullreg);
    if (match && match.length > 0) {
      for (let i = 0; i < match.length; i++) {
        const matchParts = match[i].split(regex);
        resultHtml = resultHtml.replace(
          match[i],
          this.createVimeoEmbed(matchParts[1])
        );
      }
    }
    return resultHtml;
  }

  public createYoutubeEmbed(key) {
    return (
      '<div class="aspect-ratio-video"><iframe src="' +
      'https://www.youtube.com/embed/' +
      key +
      '" frameborder="0" allowfullscreen></iframe></div>'
    );
  }

  public createVimeoEmbed(key) {
    return (
      '<div class="aspect-ratio-video"><iframe src="' +
      'https://player.vimeo.com/video/' +
      key +
      '" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe></div>'
    );
  }
}
